import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=70bf3e1c"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports